import { isEighteenYearsOld } from "src/utils/helpers";

const isNomineeAboveEighteen = (values: any, currentPath: string) => {
  const dotSplit = currentPath.split(".");
  const currentIndexDob = values.users[dotSplit[1]].dateOfBirth;
  if (!currentIndexDob) return true;
  const isAboveEighteen = isEighteenYearsOld(currentIndexDob);
  return isAboveEighteen;
};

const validateGuardianName = (value: string, values: any, currentPath: string) => {
  const isAboveEighteen = isNomineeAboveEighteen(values, currentPath);
  return isAboveEighteen || (!isAboveEighteen && value)
    ? null
    : "Guardian Name cannot be empty";
};

const validateGuardianAddress = (value: string, values: any, currentPath: string) => {
  const isAboveEighteen = isNomineeAboveEighteen(values, currentPath);
  return isAboveEighteen || (!isAboveEighteen && value.length >= 10)
    ? null
    : "Guardian Address must have at least 10 letters";
};

const validateGuardianPhone = (value: string, values: any, currentPath: string) => {
  const isAboveEighteen = isNomineeAboveEighteen(values, currentPath);
  return isAboveEighteen || (!isAboveEighteen && String(value).length === 10)
    ? null
    : "Guardian Phone number should be 10 digits";
};

const validateGuardianEmail = (value: string, values: any, currentPath: string) => {
  const isAboveEighteen = isNomineeAboveEighteen(values, currentPath);
  const isValidMail = /^\S+@\S+$/.test(value);
  return isAboveEighteen || (!isAboveEighteen && isValidMail) ? null : "Invalid Guardian Email";
};

const validateGuardianRelation = (value: string, values: any, currentPath: string) => {
  const isAboveEighteen = isNomineeAboveEighteen(values, currentPath);
  return isAboveEighteen || (!isAboveEighteen && value)
    ? null
    : "Guardian Relation cannot be empty";
};

export {
  validateGuardianName,
  validateGuardianAddress,
  validateGuardianPhone,
  validateGuardianEmail,
  validateGuardianRelation,
};
